import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deactivateSite = (pin: string): AxiosPromise =>
  instance.put(`/api/sites/${pin}/deactivate`);

export default deactivateSite;
